export default __webpack_public_path__ + "static/media/RAMADA05.f0fb9419.jpg";